import React, { useEffect, useState } from 'react';
import './SystemPages.css';

function InfoPage({ user, onUserUpdate }) {
  const [slack, setSlack] = useState(user?.slack || 'U0BE5FDN97C');
  const [status, setStatus] = useState('idle');
  const [cryptoWallet, setCryptoWallet] = useState(user?.cryptoWallet || '');
  const [walletStatus, setWalletStatus] = useState('idle');

  useEffect(() => {
    setSlack(user?.slack || 'U0BE5FDN97C');
    setCryptoWallet(user?.cryptoWallet || '');
  }, [user]);

  const saveProfileField = async (field, value, setFieldStatus) => {
    setFieldStatus('saving');
    try {
      const response = await fetch('/api/data', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ collection: 'users', id: user?.id, changes: { [field]: value.trim() } }),
      });
      if (!response.ok) throw new Error('Не удалось сохранить данные профиля');
      onUserUpdate?.({ ...user, [field]: value.trim() });
      setFieldStatus('saved');
      window.setTimeout(() => setFieldStatus('idle'), 1800);
    } catch (error) {
      console.error(error);
      setFieldStatus('error');
    }
  };

  const saveSlack = () => saveProfileField('slack', slack, setStatus);
  const saveCryptoWallet = () => saveProfileField('cryptoWallet', cryptoWallet, setWalletStatus);

  return (
    <div className="profile-page">
      <h1 className="profile-page__title">Профиль</h1>

      <section className="profile-card">
        <h2 className="profile-card__title">Основная информация</h2>
        <div className="profile-card__body profile-details">
          <div className="profile-details__label">Имя</div><div>{user?.name || '—'}</div>
          <div className="profile-details__label">Алиас</div><div>{user?.alias || 'klih'}</div>
          <div className="profile-details__label">Email</div><div>{user?.email || '—'}</div>
          <div className="profile-details__label">Telegram</div><div>{user?.telegram || 'kl_traff'}</div>
          <div className="profile-details__label">Slack</div><div>{user?.slack || 'U0BE5FDN97C'}</div>
          <div className="profile-details__label">USDT TRC20</div><div>{user?.cryptoWallet || '—'}</div>
        </div>
      </section>

      <section className="profile-card">
        <h2 className="profile-card__title">Slack</h2>
        <div className="profile-card__body">
          <p className="profile-card__hint">
            Укажите ваш Slack Member ID (например <code>U0BE1DU9ZAR</code>) — найти можно в профиле Slack → «Copy member ID».
          </p>
          <div className="profile-slack-form">
            <input
              className="profile-slack-form__input"
              value={slack}
              onChange={(event) => { setSlack(event.target.value); setStatus('idle'); }}
              placeholder="Slack Member ID"
            />
            <button className="profile-slack-form__save" type="button" onClick={saveSlack} disabled={status === 'saving'}>
              {status === 'saving' ? 'Сохранение…' : 'Сохранить'}
            </button>
          </div>
          <button className="profile-slack-form__clear" type="button" onClick={() => { setSlack(''); setStatus('idle'); }}>
            Очистить
          </button>
          {status === 'saved' && <div className="profile-slack-form__message">Сохранено</div>}
          {status === 'error' && <div className="profile-slack-form__message profile-slack-form__message--error">Ошибка сохранения</div>}
        </div>
      </section>

      <section className="profile-card">
        <h2 className="profile-card__title">Криптокошелёк (USDT TRC20)</h2>
        <div className="profile-card__body">
          <p className="profile-card__hint">Укажите адрес кошелька для получения USDT в сети TRC20.</p>
          <div className="profile-slack-form">
            <input
              className="profile-slack-form__input"
              value={cryptoWallet}
              onChange={(event) => { setCryptoWallet(event.target.value); setWalletStatus('idle'); }}
              placeholder="Адрес USDT TRC20"
              autoComplete="off"
              spellCheck="false"
            />
            <button
              className="profile-slack-form__save"
              type="button"
              onClick={saveCryptoWallet}
              disabled={walletStatus === 'saving'}
            >
              {walletStatus === 'saving' ? 'Сохранение…' : 'Сохранить'}
            </button>
          </div>
          {walletStatus === 'saved' && <div className="profile-slack-form__message profile-slack-form__message--below">Сохранено</div>}
          {walletStatus === 'error' && <div className="profile-slack-form__message profile-slack-form__message--error profile-slack-form__message--below">Ошибка сохранения</div>}
        </div>
      </section>
    </div>
  );
}

export default InfoPage;
